import { CSSProperties, ReactElement, ReactNode } from 'react';
import styles from './ui-menu.module.scss';

type UIMenuProps = {
    children?: ReactNode;
    scroll?: boolean;
    maxHeight?: number;
    maxWidth?: number;
    header?: ReactNode;
    footer?: ReactNode;
};

export function UIMenu(props: UIMenuProps): ReactElement {
    const { children, scroll, maxHeight, maxWidth, header, footer } = props;

    const containerStyle: CSSProperties = {};
    if (maxHeight !== undefined) {
        containerStyle.maxHeight = maxHeight;
    }

    if (maxWidth !== undefined) {
        containerStyle.maxWidth = maxWidth;
    }

    const contentStyle: CSSProperties = {};
    if (scroll !== undefined) {
        contentStyle.overflowY = 'scroll';
    }

    return (
        <div style={containerStyle} className={styles.container}>
            {header && <div className={styles.header}>{header}</div>}

            <div style={contentStyle} className={styles.content}>
                {children}
            </div>

            {footer && <div className={styles.footer}>{footer}</div>}
        </div>
    );
}
